import API from 'app/api';
import { extractData } from 'app/api/requests/parsers/response';
import { transifexLocales } from 'app/router/constants/routerLocales';

const fetchTranslations = ({ locale }) =>
  API.Transifex.fetchTranslations({ locale: transifexLocales[locale] }).then(
    extractData,
  );

export { fetchTranslations };
